// Need to find a better way to discern between what error should be shown
// Field doesn't work because if "pattern" is shown multiple times it requires special logic to prevenet duplicates
export const patternErrors = {
    "^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(-((0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(\\.(0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(\\+([0-9a-zA-Z-]+(\\.[0-9a-zA-Z-]+)*))?$":"- Must be semantic version, 0.0.0 format",
    "^(([a-zA-Z0-9]+);?)+[a-zA-Z0-9]$":"- Must be a semicolon separated list of CDSIDs. Example: 'cdsid1;cdsid2'",
    "^(ht|f)tp(s?)://[0-9a-zA-Z]([-.w]*[0-9a-zA-Z])*(:(0-9)*)*(/?)([a-zA-Z0-9-.?,'/\\+&amp;%$#_]*)?$":"- Must be a File URL",
    "^(.*\\.mdx)$":"- Must be an '.mdx' file",
    "^([a-zA-Z0-9]+)_([a-zA-Z0-9]+)_([a-zA-Z0-9]+)$":"- Must follow standard naming. Example: 'znl_RZM_HSM'",
    "^(.*\\.tgz)$|^(.*\\.tar\\.gz)$":"- Must be a '.tar.gz' file or a '.tgz' file",
    "^(.*CNR_.*)$":"- Must contain 'CNR_' in between name and version",
    "^()$|^(0x)[a-fA-F0-9]+$":"- Must be a hex value beginning with '0x'",
    "^()$|^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(-((0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(\\.(0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(\\+([0-9a-zA-Z-]+(\\.[0-9a-zA-Z-]+)*))?$":"- Must be semantic version, 0.0.0 format with no prefix or postfix",
    "^$": "- Blank",
    "^\\(.*\\)$":"- A series of MFAL codes with logic. Example: '(DR--B)&(D3IFR)&((WAFAB)||(WAFAC)||(WANAB))'",
    "^ALWAYS$|^TRUE$|^FALSE$|^N/A$":"- 'ALWAYS', 'TRUE', 'FALSE', or 'N/A' (Case Sensitive)",
    "^[0-9]+.[0-9]+.[0-9]$": "- Must be in the format of 'number.number.number'",
    "^[a-zA-Z0-9]{1,6}-[a-zA-Z0-9]{1,6}-[a-zA-Z0-9]{1,6}$":"- Must match this format: prefix(1~6 characters)-base(1~6 characters)-suffix(1~6 characters). Example: \"A1B2C3-D4E5F6-G7H234\"",
    "^(?!.*(P800|V801|P736))[a-zA-Z0-9-]+_[a-zA-Z0-9-]+$": "- Must match this format <ProjectKey>_<ECUName>, and vehicle programs SHOULD NOT be present in the SRP name",
    "^[0-9]\\d*\\/[0-9]\\d*$": "- Must be in the format of 'number/number'",
    // Diagaddress
    "^(0x)[a-fA-F0-9]+$": "Must be a hex value beginning with '0x'",
    "^[a-zA-Z0-9]+$": "- Must be alphanumeric",
    "^(https?://.*.mdx)$": "- Must be a MDX file URL",
}

export const schemaErrors = {
    "minLength":"- Must not be blank",
    "minItems":"- Must not be empty",
    "enum":"- Must have an option selected",
    "uri":"- Must be a File URL",
    "oneOf":"Must match one of the following:",
    "uniqueItems":"- Must not have duplicate items ",
    "minimum":"- Must not be less than "
}
